/**
 * Welke in de onboarding ingevulde vervaldatums liggen in het verleden? Eén bron
 * voor de melding aan de kandidaat, de melding aan HR en de HR-controle.
 * Een certificaat telt alleen als het vinkje "ik heb dit certificaat" aan staat.
 */
const VERVAL_VELDEN: ReadonlyArray<{ veldId: string; label: string; alleenAls?: string }> = [
  { veldId: 'rijbewijsVervalDatum', label: 'Rijbewijs' },
  { veldId: 'vcaGeldigTot', label: 'VCA-certificaat', alleenAls: 'heeftVca' },
  { veldId: 'ehboGeldigTot', label: 'EHBO-diploma', alleenAls: 'heeftEhbo' },
  { veldId: 'bhvGeldigTot', label: 'BHV-certificaat', alleenAls: 'heeftBhv' },
]

export interface VerlopenOnboardingVeld {
  veldId: string
  label: string
  /** yyyy-MM-dd */
  datum: string
}

export function verlopenOnboardingVelden(
  data: Record<string, unknown>,
  vandaagYmd: string,
): VerlopenOnboardingVeld[] {
  const uit: VerlopenOnboardingVeld[] = []
  for (const { veldId, label, alleenAls } of VERVAL_VELDEN) {
    if (alleenAls && data[alleenAls] !== true) continue
    const waarde = data[veldId]
    if (typeof waarde !== 'string' || !/^\d{4}-\d{2}-\d{2}/.test(waarde)) continue
    const datum = waarde.slice(0, 10)
    if (datum < vandaagYmd) uit.push({ veldId, label, datum })
  }
  return uit
}
